import React, { Component } from 'react'
import { connect } from 'react-redux'

import {
  verifyEvents,
  markFalsePositive,
  clearIncident,
  removeIncident,
  eventReceived,
} from '../../../store/entities/events'
import { unverifyEventsThreatIntel, unSetThreatIntelStatusCode } from '../../../store/entities/threatintel'

import FPTypes from '../../../utilities/falsePositiveTypes'

import updateSvg from '../../../assets/update.svg'
import checkMark from '../../../assets/checkMark.svg'
import protect from '../../../assets/protect.svg'
import trash from '../../../assets/trash.svg'
import './updatePopover.scss'
import { Dropdown } from 'react-bootstrap'
import { Link , withRouter} from 'react-router-dom'
import ConfirmPopup from './confirmPopup'
import {
  confirmFalsePositive,
  confirmClear,
  confirmUnverify
} from '../../../utilities/config'
import { eventTypes } from '../../../utilities/eventTypes'
import { isGlobalView, isSuperFeedView } from '../../../utilities/config'
const threatIntelScreens = ["ThreatIntelDetails", "ThreatIntelList", "ThreatIntelGrid"];
const incidentScreens = ["incidentDetails", "incidentList", "incidentGrid"];
const superFeedScreens = ["superFeedDetails", "superFeedList", "superFeedGrid"];
const unverifySuccessObj = {
  icon: '',
  type: 'success',
  title: 'Event removed from Threat Intelligence',
  description: 'Event has been submitted for Unverification. It will be removed from Threat Intelligence Feed soon.',
  buttons: 'O',
}

const unverifyErrorObj = {
  icon: '',
  type: 'error',
  title: 'Event could not be removed from Threat Intelligence',
  description: 'Oops! Something went wrong. Please try again later.',
  buttons: 'O',
}

class UpdatePopover extends Component {
  state = {
    // showConfirm_Verify: false,
    showConfirm_Unverify: false,
    showConfirm_FP: false,
    showConfirm_Clear: false,
    showSuccessErrorPopup: false,
    verify: this.props.event.triagedEvent,
    context : this.props.context || 'threat-intel-feed'
  }

  redirectToIncidents = () => {
    const { selectedCustomer, history, from } = this.props
    if (from && from === 'incidentDetails') {
     history.push(`${isGlobalView(selectedCustomer.organizationName)? '/tenants': '/customers'}/${selectedCustomer.id}/incidents`)
    }
    else if (from && from === 'ThreatIntelDetails') {
      history.push(`/threat-intel-feed`);
    } else if (from && superFeedScreens.includes(from)) {
      history.push(`/super-feed`);
    }
  }

  handleVerify = () => {
    const { event, selectedCustomer, allEvents, from } = this.props
    if(isSuperFeedView(selectedCustomer.organizationName)){
        this.props.eventReceived({ response: event })
      this.props.history.push({
        pathname: `/customers/${event.customerId}/threat-intel/${event.eventId}`,
        state: superFeedScreens.includes(from) ? { from: '/super-feed' } : {}
      })
      return
    }
    this.props.eventReceived({ response: event })
    if (!isGlobalView(selectedCustomer.organizationName)) {
      
        this.props.history.push({ pathname : `/customers/${selectedCustomer.id}/threat-intel/${event.id}`})
        return
    }
    this.props.history.push({pathname : `/tenants/${selectedCustomer.id}/${event.customerId}/threat-intel/${event.id}`})
  }

  handleUnverify = () => {
    this.setState({
      showConfirm_Unverify: true,
    })
  }

  handleFalsePositive = () => {
    this.setState({
      showConfirm_FP: true,
    })
  }

  handleClear = () => {
    this.setState({
      showConfirm_Clear: true,
    })
  }

  markVerify = () => {
    const { event, verifyEvents } = this.props
    const {
      id: eventId,
      url,
      detectionTime,
      email: user,
      userAction,
      brands,
      customerId
    } = event
    verifyEvents(
      [{ eventId, url, detectionTime, user, userAction, brands }],
      customerId,
    )
    this.setState({ verify: true })
    this.redirectToIncidents()
  }

  markUnverify = () => {
    const { event, from } = this.props
    let { id } = event
    let customerId = event.customerId
    if (from && superFeedScreens.includes(from)) {
      id = event.eventId
    } 
    this.setState({ verify: false, showConfirm_Unverify: false })
    this.props.unverifyEventsThreatIntel(id, customerId);
    this.redirectToIncidents();
  }

  markFalsePositive = () => {
    const { event, markFalsePositive, from } = this.props
    const { url , customerId } = event
    let { id: eventId } = event
    if(from && superFeedScreens.includes(from)) {
      eventId = event.eventId
    }
    markFalsePositive(
      [{ eventId, url, falsePositiveType: FPTypes.DEFAULT_FP }],
     customerId,
    )
    this.setState({
      showConfirm_FP: false,
    })
    this.redirectToIncidents()
  }

  markClear = () => {
    const { event, clearIncident, from } = this.props
    const { customerId } = event
    let { id : eventId} = event
    if(from && superFeedScreens.includes(from)) {
      eventId = event.eventId
    }
    clearIncident({ eventId }, customerId)
    this.setState({
      showConfirm_Clear: false,
    })
    this.redirectToIncidents()
  }

  handleClose = () => {
    this.setState({
      ...this.state,
      showConfirm_FP: false,
      showConfirm_Clear: false,
      showConfirm_Unverify: false,
      showSuccessErrorPopup: false,
    })
    this.props.unSetThreatIntelStatusCode();
  }

  render() {
    const { tokenRoles, event , from, context} = this.props;
    const isPixmAdmin = tokenRoles === 'PixmAdmin';
    const hideVerify =
      // event.type === eventTypes.reported_phish ||
      event.type === eventTypes.google_form_password || 
      context === 'threat-intel';

    const showUnverify = from && threatIntelScreens.includes(from) || superFeedScreens.includes(from);
    // show Mark False Positive for all only Incident Types and not for Reported Phish.
    const showFalsePositive = (from && incidentScreens.includes(from) || superFeedScreens.includes(from)) && event.type !== eventTypes.reported_phish;
    const showClear = from && incidentScreens.includes(from) || superFeedScreens.includes(from);
    // Show Verify only if the event is not PIXM Verified and is of type Incident or Reported Phish
    const showVerify = (!event.isPixmVerified && event.type !== undefined && (event.type === eventTypes.incident || event.type === eventTypes.reported_phish)) || (event.isVerified !== undefined && event.isVerified === "N")
    return (
      <>
        <Dropdown>
          {isPixmAdmin || !(hideVerify)   && !this.state.verify ? (<Dropdown.Toggle
            bsPrefix="toggle"
            as={Link}
            to="#!"
            className="stausText"
          >
            <img src={updateSvg} alt="update-icon" style={{ height: '19px' }} />
            <span style={{fontSize: '14px'}}>Update Status</span>
          </Dropdown.Toggle>): null}
          { hideVerify || this.state.verify ? (
            <Dropdown.Menu className="actionContainer">
              <Dropdown.Item className="menuItem" onClick={this.handleClear}>
                <img src={trash} className="actionImg" />
                Clear
              </Dropdown.Item>
            </Dropdown.Menu>
          ) : (
            <>
              {this.props.tokenRoles === 'PixmAdmin' ? (
                <Dropdown.Menu className="actionContainer">
                  { showVerify ?
                  <Dropdown.Item
                    className="menuItem"
                    onClick={this.handleVerify}
                  >
                    <img src={checkMark} className="actionImg" />
                    Verify
                  </Dropdown.Item> :
                  (showUnverify) &&
                  <Dropdown.Item
                    className="menuItem"
                    onClick={this.handleUnverify}
                  >
                    <img src={checkMark} className="actionImg" />
                    Unverify
                  </Dropdown.Item>
                  } 
                  {showFalsePositive ? <Dropdown.Item
                    className="menuItem"
                    onClick={this.handleFalsePositive}
                  >
                    <img src={protect} className="actionImg" />
                    Mark False Positive
                  </Dropdown.Item> : null}
                 { showClear ? <Dropdown.Item
                    className="menuItem"
                    onClick={this.handleClear}
                  >
                    <img src={trash} className="actionImg" />
                    Clear
                  </Dropdown.Item> : null}
                </Dropdown.Menu>
              ) : (
                <Dropdown.Menu className="actionContainer">
                  <Dropdown.Item
                    className="menuItem"
                    onClick={this.handleFalsePositive}
                  >
                    <img src={protect} className="actionImg" />
                    Mark False Positive
                  </Dropdown.Item>
                </Dropdown.Menu>
              )}
            </>
          )}
        </Dropdown>
        {/* {this.state.showConfirm_Verify && (
          <ConfirmPopup
            details={confirmVerify}
            onYesClick={this.markVerify}
            onCancelClick={this.handleClose}
          />
        )} */}
        {this.state.showConfirm_Unverify && (
          <ConfirmPopup
            details={confirmUnverify}
            onYesClick={this.markUnverify}
            onCancelClick={this.handleClose}
          />
        )}
        {this.state.showConfirm_FP && (
          <ConfirmPopup
            details={confirmFalsePositive}
            onYesClick={this.markFalsePositive}
            onCancelClick={this.handleClose}
          />
        )}
        {this.state.showConfirm_Clear && (
          <ConfirmPopup
            details={confirmClear}
            onYesClick={this.markClear}
            onCancelClick={this.handleClose}
          />
        )}
        {this.props.verifyStatusCode && (
          <ConfirmPopup
            details={this.props.verifyStatusCode === 200 ? unverifySuccessObj : unverifyErrorObj}
            onCloseClick={this.handleClose} 
          />
        )}
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  tokenRoles: state.entities.user.roles,
  selectedCustomer: state.entities.customers.selected,
  verifyStatusCode: state.entities.threatintel.verifyStatusCode,
  allEvents: state.entities.events.list,

})

const mapDispatchToProps = (dispatch) => ({
  verifyEvents: (events, customerId) =>
    dispatch(verifyEvents(events, customerId)),
  unverifyEventsThreatIntel: (Id, customerId) =>
    dispatch(unverifyEventsThreatIntel(Id, customerId)),
  markFalsePositive: (events, customerId) =>
    dispatch(markFalsePositive(events, customerId)),
  clearIncident: (events, customerId) =>
    dispatch(clearIncident(events, customerId)),
  removeIncident: (events, customerId) =>
    dispatch(removeIncident(events, customerId)),
  eventReceived: (data) => dispatch(eventReceived(data)),
  unSetThreatIntelStatusCode: () => dispatch(unSetThreatIntelStatusCode())
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UpdatePopover))
